import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: string | number
  height?: string | number
  color?: Color
  className?: string
  dataTestid?: string
}

const CheckSvg = ({ width, height, color, className, dataTestid }: Props) => (
  <svg
    data-testid={dataTestid}
    width={width}
    height={height}
    className={className}
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6574 1.2036C14.5648 1.1119 14.4546 1.03912 14.3332 0.989454C14.2118 0.939786 14.0816 0.914215 13.9501 0.914215C13.8186 0.914215 13.6884 0.939786 13.567 0.989454C13.4456 1.03912 13.3354 1.1119 13.2428 1.2036L5.82138 8.50187L2.70337 5.42995C2.60722 5.33873 2.49372 5.267 2.36934 5.21887C2.24496 5.17073 2.11215 5.14712 1.97848 5.14939C1.84482 5.15167 1.71292 5.17977 1.59031 5.2321C1.4677 5.28444 1.35679 5.35998 1.26391 5.4544C1.17103 5.54883 1.098 5.66031 1.04898 5.78245C0.999966 5.9046 0.975928 6.03504 0.978241 6.16631C0.980553 6.29758 1.00917 6.42712 1.06246 6.54753C1.11575 6.66794 1.19266 6.77686 1.28882 6.86808L5.1141 10.6248C5.20671 10.7165 5.31688 10.7893 5.43828 10.839C5.55967 10.8886 5.68987 10.9142 5.82138 10.9142C5.95289 10.9142 6.08309 10.8886 6.20448 10.839C6.32588 10.7893 6.43605 10.7165 6.52866 10.6248L14.6574 2.64173C14.7585 2.55012 14.8392 2.43893 14.8944 2.31518C14.9496 2.19142 14.9781 2.05777 14.9781 1.92267C14.9781 1.78756 14.9496 1.65392 14.8944 1.53016C14.8392 1.4064 14.7585 1.29521 14.6574 1.2036Z"
      fill={color}
    />
  </svg>
)

CheckSvg.defaultProps = {
  width: 15,
  height: 11,
  color: colors.Primary.GreyText,
  className: '',
}

export default CheckSvg
